import React from 'react';
import { Card, CardTitle, CardText, CardActions } from 'react-toolbox/lib/card';
import {Button} from '../../../../../../common/components';
import glamorous from 'glamorous';

const StyledCardTitle = glamorous(CardTitle, { rootEl: 'div' })({
  '& div': {
    width: '100%',
    boxShadow: 'none !important',
  },
});

export default ({ toggleView, goForward }) => {
  return (
    <Card>
      <StyledCardTitle>Are you sure?</StyledCardTitle>
      <CardText>
        As a valued NFIB Member, you will have a voice with your Local, State, and Federally elected representatives.
      </CardText>
      <CardText>
        However, without a Home Address we will not be able to accurately link your membership and identify all of your representatives.
      </CardText>
      <CardActions style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
        <Button
          label="Enter Home Address"
          onClick={() => toggleView('HomeAddress')}
          style={{marginRight: '4px'}}
        />
        <Button
          label="Continue"
          onClick={goForward}
        />
      </CardActions>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/Representatives/ContinuePage.js